import React from 'react'
import styled from 'styled-components'
import layiMark from '../ChatbotWidget/assets/layi-mark.svg'
import layiMarkOutline from '../ChatbotWidget/assets/layi-mark-outline.svg'

// The LAYI mark as a navigation icon. It is an image, not a Font Awesome glyph, so it follows the
// glyphs' convention by swapping two renderings (CSS cannot change an image's source): white
// outlines at the inactive glyphs' 40% when LAYI is not the current page, the mark's colours when
// it is, and also while the enclosing `.nav-link` is hovered.

export const NAV_LINK_CLASS = 'nav-link'

const MarkBox = styled.span`
  position: relative;
  display: block;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  transition: transform 0.2s ease;
  .${NAV_LINK_CLASS}:hover & {
    transform: ${props => (props.lift ? 'scale(1.1) translateY(-1px)' : 'none')};
  }
`

const Mark = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const OutlineMark = styled(Mark)`
  display: ${props => (props.active ? 'none' : 'block')};
  opacity: 0.4;
  .${NAV_LINK_CLASS}:hover & {
    display: none;
  }
`

const ColourMark = styled(Mark)`
  display: ${props => (props.active ? 'block' : 'none')};
  .${NAV_LINK_CLASS}:hover & {
    display: block;
  }
`

export default function LayiMark({ active, size = 44, lift = true, testId }) {
  return (
    <MarkBox data-testid={testId} size={size} lift={lift}>
      <OutlineMark src={layiMarkOutline} alt="LAYI" active={active} />
      <ColourMark src={layiMark} alt="" active={active} />
    </MarkBox>
  )
}
